import PropTypes from 'prop-types';
import React from 'react';

/* ========================================================================= */
/* Component(s) */
/* ========================================================================= */

/**
 * @param {PropTypes.InferProps<typeof propTypes>} props
 */
const IconStapleBack = ({ className }) => {
    return (
        <svg
            className={'icon-staple' + (className ? ` ${className}` : '')}
            fill='none'
            viewBox='0 0 17 17'
            xmlns='http://www.w3.org/2000/svg'><path
                d='M16 16 9.73223 9.73223M7.26777 7.26777 1 1'
                stroke='#0E0E0E'
                strokeLinecap='round'
                strokeWidth='1.5'/></svg>
    );
};

/* ========================================================================= */
/* Typing and export(s) */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string
};

IconStapleBack.propTypes = propTypes;

export default IconStapleBack;
